module.exports = __webpack_public_path__ + "static/media/accessoires-veste.f35d90d4.jpg";